import PropTypes from 'prop-types';
import {useMemo} from 'react';
import {useTheme} from 'react-jss';
import {connect} from 'react-redux';
import InputField from '../../../form/InputField';
import Translation from '../../../lang/Translation';
import {getPudo} from '../../../selectors/PudoSelectors';
import addressDefinitionsByCountry from '../address-definitions-by-country';
import useStyles from './CollectionAddressee.styles';

export function CollectionAddressee(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  const collectionHelpLabel = (
    <div className={classes.collectionHelpLabel}>
      <Translation>checkout.delivery.address.field.collection.addressee.help.text</Translation>
    </div>
  );
  
  const addressDefinitionByCountry = useMemo(() => ({
    ...addressDefinitionsByCountry.get(props.country).find(address => address.name === 'addressee'),
  }), [props.country, address => address.name]);
  
  const definedField = {
    ...addressDefinitionByCountry,
    label: 'address.name',
    helperText: collectionHelpLabel,
    type: 'text',
    required: true,
  };
  
  return (
    <div className={classes.collectionAddressee} data-test="CollectionAddressee">
      <div>
        <InputField
          fieldContainer={props.fieldContainer}
          definedField={definedField}
          value={props.collectorName}
          fieldNamePrefix="collection"
        />
      </div>
    </div>
  );
}

CollectionAddressee.propTypes = {
  fieldContainer: PropTypes.shape({
    deregisterField: PropTypes.func.isRequired,
    registerField: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
  }).isRequired,
  collectorName: PropTypes.string,
  accountName: PropTypes.string,
  country: PropTypes.string,
};

const mapStateToProps = (state) => {
  const pudo = getPudo(state);
  const country = pudo.currentLocation?.country;
  const collectorName = getPudo(state)?.collectorName || getPudo(state)?.savedAddresses[0]?.name || '';
  return {
    country: country || '',
    collectorName,
  };
};

export default connect(mapStateToProps)(CollectionAddressee);
